/**
 * Copyright ©2026 Drivepoint
 */

import React from "react";
import "./BrandAtmosphere.css";

export type BrandAtmosphereProps = {
  tone?: "dark" | "light";
};

export default function BrandAtmosphere({tone = "dark"}: BrandAtmosphereProps): any {
  return <div className={`brand-atmosphere brand-atmosphere-${tone}`} aria-hidden="true">
    <div className="brand-atmosphere-glow brand-atmosphere-glow-top" />
    <div className="brand-atmosphere-glow brand-atmosphere-glow-bottom" />
    <div className="brand-atmosphere-mesh">
      <span className="brand-atmosphere-mesh-tracer brand-atmosphere-mesh-tracer-horizontal brand-atmosphere-mesh-tracer-horizontal-one" />
      <span className="brand-atmosphere-mesh-tracer brand-atmosphere-mesh-tracer-horizontal brand-atmosphere-mesh-tracer-horizontal-two" />
      <span className="brand-atmosphere-mesh-tracer brand-atmosphere-mesh-tracer-vertical brand-atmosphere-mesh-tracer-vertical-one" />
      <span className="brand-atmosphere-mesh-tracer brand-atmosphere-mesh-tracer-vertical brand-atmosphere-mesh-tracer-vertical-two" />
    </div>
  </div>;
}
